export interface LocationWeather {
  id: string;
  name: string;
  region: string;
  country: string;
  temperature: number;
  condition: string;
  conditionIcon: string;
  isCurrentLocation?: boolean;
}

export const currentLocation: LocationWeather = {
  id: "current",
  name: "Boucherville",
  region: "QC",
  country: "Canada",
  temperature: Math.floor(Math.random() * 30) - 20,
  condition: "Nuageux",
  conditionIcon: "fa-cloud",
  isCurrentLocation: true,
};

export const popularLocations: LocationWeather[] = [
  {
    id: "montreal",
    name: "Montreal",
    region: "QC",
    country: "Canada",
    temperature: Math.floor(Math.random() * 30) - 20,
    condition: "Faible neige",
    conditionIcon: "fa-snowflake",
  },
  {
    id: "quebec",
    name: "Quebec",
    region: "QC",
    country: "Canada",
    temperature: Math.floor(Math.random() * 30) - 20,
    condition: "Faible neige",
    conditionIcon: "fa-snowflake",
  },
];
